import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, sessionToken } = useAuth();

  if (loading) {
    return <div>Cargando...</div>; // Puedes usar un spinner o una pantalla de carga
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;     
  }

  return children;
};

export default ProtectedRoute;
